/**
 * Module mirror of the ViewMode context's `adminToolsWhileImitating`, for the
 * readers that cannot use a hook.
 *
 * Route `beforeLoad` guards (`requireAdmin`) run outside React and before any
 * component of the matched route renders, so they read this the way the
 * feature-flag resolvers read `imitationState`'s singleton.
 *
 * Held in memory only: every page load starts with admin tools OFF — including
 * the hard reloads that begin and end imitation — so an admin's earlier opt-in
 * can never silently carry into the next imitated session.
 *
 * Kept in its own module rather than beside the provider so
 * `view-mode.context.tsx` exports components and hooks only, and Fast Refresh
 * can still preserve component state there.
 */
let _adminToolsWhileImitating = false;

export function isAdminToolsWhileImitatingEnabled(): boolean {
  return _adminToolsWhileImitating;
}

/**
 * Kept as a function rather than an inline assignment in the provider: the
 * React Compiler bails out of optimizing any component that reassigns a
 * module-scope binding directly.
 */
export function writeAdminToolsMirror(enabled: boolean): void {
  _adminToolsWhileImitating = enabled;
}
